const lowerCase = (str: string) => {
	return str[0].toLowerCase() + str.substring(1);
};

export default lowerCase;
